import React from 'react'
import { ScreeningQuestion } from '../../../types/sponsorships/campaigns'
import './style.scss'

const DEFAULT_BINARY_LABELS = ['Yes', 'No'] as const

const ScreeningQuestionBinary: React.FC<{
  index: number
  question: ScreeningQuestion
  value: string | number // 1 or 0
  onChange: (value: number) => void
  highlightError?: boolean
}> = ({ index, question, value, onChange, highlightError }) => {
  const opts = question.options?.filter(Boolean) ?? []
  const choices =
    opts.length >= 2 ? [opts[0], opts[1]] : [...DEFAULT_BINARY_LABELS]

  const groupName = `screening-binary-${question.id}`

  return (
    <div className="screening-binary">
      <h3
        className="screening-binary__title fw-600 text-dark fs-16"
        id={`${groupName}-label`}
      >
        {index + 1}. {question.question}
      </h3>
      <div
        className="screening-binary__choices gap-075"
        role="radiogroup"
        aria-labelledby={`${groupName}-label`}
      >
        {choices.map((choice) => {
          const selected = (value === 1 ? 'Yes' : (value === 0 ? 'No' : '')) === choice
          return (
            <label
              key={choice}
              className={`screening-binary__btn fs-14 text-dark${selected ? ' is-selected' : ''}`}
            >
              <span className="screening-binary__btn-text">{choice}</span>
              <input
                type="radio"
                className="visually-hidden"
                name={groupName}
                value={choice}
                checked={selected}
                onChange={() => onChange(choice === 'Yes' ? 1 : 0)}
              />
            </label>
          )
        })}
      </div>
      {highlightError && <div className="text-danger fs-14">Please select a valid option</div>}
    </div>
  )
}

export default ScreeningQuestionBinary
